import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonState } from "../../../types/state/common";
import {
  callPhpWorkflow,
  getDepartments,
  getSites,
  getAssignedTimeoffCategories,
  getUnreadNotifCount,
  getAllTimeoffCategories,
  fetchLastPunch,
  getJobCodes,
  fetchAttendanceTags,
} from "./api";
import { TimeoffCategoryType } from "../../../types";

const initialState: CommonState = {
  sites: [],
  sitesTimestamp: undefined,
  departments: [],
  departmentsTimestamp: undefined,
  jobCodes: [],
  jobCodesTimestamp: undefined,
  attendanceTags: [],
  attendanceTagsTimestamp: undefined,
  LastPunchState: null,
  assignedTimeoffCategories: [],
  isLoadingAssignedCategories: false,
  isCallingWorkflow: false,
  allTimeoffCategories: [],
  isLoadingAllCategories: false,

  // unread notification count
  isLoadingUnreadNotifCount: false,
  unreadNotifCount: 0,
};

export const CommonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    clearSites: (state) => {
      state.sites = [];
    },

    decrementUnreadNotifCount: (state) => {
      if (state.unreadNotifCount > 0) {
        state.unreadNotifCount -= 1;
      }
    },
  },
  extraReducers: {
    // get sites
    [getSites.fulfilled.type]: (state, { payload }) => {
      if (payload.data) {
        state.sites = payload.data;
        state.sitesTimestamp = Date.now();
      }
    },

    [getSites.rejected.type]: (state) => {
      state.sites = [];
      state.sitesTimestamp = undefined;
    },

    [getSites.pending.type]: (state) => {
      state.sites = [];
    },

    // get departments
    [getDepartments.fulfilled.type]: (state, { payload }) => {
      if (payload.data) {
        state.departments = payload.data;
        state.departmentsTimestamp = Date.now();
      }
    },

    [getDepartments.rejected.type]: (state) => {
      state.departments = [];
      state.departmentsTimestamp = undefined;
    },

    [getDepartments.pending.type]: (state) => {
      state.departments = [];
    },
    // getJobCodes
    [getJobCodes.fulfilled.type]: (state, { payload }) => {
      if (payload.data) {
        state.jobCodes = payload.data;
        state.jobCodesTimestamp = Date.now();
      }
    },

    [getJobCodes.rejected.type]: (state) => {
      state.jobCodes = [];
      state.jobCodesTimestamp = undefined;
    },

    [getJobCodes.pending.type]: (state) => {
      state.jobCodes = [];
    },
    // attendanceTags
    [fetchAttendanceTags.fulfilled.type]: (state, { payload }) => {
      if (payload.data) {
        state.attendanceTags = payload.data;
        state.attendanceTagsTimestamp = Date.now();
      }
    },

    [fetchAttendanceTags.rejected.type]: (state) => {
      state.attendanceTags = [];
      state.attendanceTagsTimestamp = undefined;
    },

    [fetchAttendanceTags.pending.type]: (state) => {
      state.attendanceTags = [];
    },

    // get assigned time off categories
    [getAssignedTimeoffCategories.fulfilled.type]: (
      state,
      action: PayloadAction<TimeoffCategoryType[]>
    ) => {
      state.isLoadingAssignedCategories = false;
      state.assignedTimeoffCategories = action.payload;
    },

    [getAssignedTimeoffCategories.rejected.type]: (state) => {
      state.isLoadingAssignedCategories = false;
      state.assignedTimeoffCategories = [];
    },

    [getAssignedTimeoffCategories.pending.type]: (state) => {
      state.isLoadingAssignedCategories = true;
      state.assignedTimeoffCategories = [];
    },

    // get all time off categories
    [getAllTimeoffCategories.fulfilled.type]: (state, { payload }) => {
      state.isLoadingAllCategories = false;
      state.allTimeoffCategories = payload;
    },

    [getAllTimeoffCategories.rejected.type]: (state) => {
      state.isLoadingAllCategories = false;
      state.allTimeoffCategories = [];
    },

    [getAllTimeoffCategories.pending.type]: (state) => {
      state.isLoadingAllCategories = true;
      state.allTimeoffCategories = [];
    },

    [callPhpWorkflow.pending.type]: (state) => {
      state.isCallingWorkflow = true;
    },

    [callPhpWorkflow.fulfilled.type]: (state) => {
      state.isCallingWorkflow = false;
    },

    [callPhpWorkflow.rejected.type]: (state) => {
      state.isCallingWorkflow = false;
    },

    [getUnreadNotifCount.fulfilled.type]: (
      state,
      action: PayloadAction<number>
    ) => {
      state.isLoadingUnreadNotifCount = false;
      state.unreadNotifCount = action.payload;
    },

    [getUnreadNotifCount.rejected.type]: (state) => {
      state.isLoadingUnreadNotifCount = false;
    },

    [getUnreadNotifCount.pending.type]: (state) => {
      state.isLoadingUnreadNotifCount = true;
    },
    [fetchLastPunch.fulfilled.type]: (state, { payload }) => {
      state.LastPunchState = payload;
    },

    [fetchLastPunch.rejected.type]: (state) => {
      state.LastPunchState = null;
    },

    [fetchLastPunch.pending.type]: (state) => {
      state.LastPunchState = null;
    },
  },
});

export const { clearSites, decrementUnreadNotifCount } = CommonSlice.actions;
export default CommonSlice.reducer;
